import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from '../../Icon';
import Popover from '@material-ui/core/Popover';
import Changer from './Changer';

import {StateContext} from '../context';

const bottom_section_styles = theme => ({
  root: {
    position:'absolute',
    bottom:0,
    left:0,
    width:'100%',
    height:'auto',
    background:theme.palette.whiteGrey
  },
  zero_margin_right: {
    margin:`0 0 4px`,
    minWidth:36
  },
  twenty_min_width: {
    minWidth: 20
  },
  list_item: {
    padding: theme.margins.sm
  },
  overflow: {
    textOverflow: 'ellipsis',
    overflow:'hidden',
    whiteSpace: 'nowrap'
  },
  rotate_icon: {
    webkitTransform: "rotate(270deg)",
    transform: "rotate(270deg)",
  },
  default_icon: {
    webkitTransform: "rotate(90deg)",
    transform: "rotate(90deg)",
  },
  pointer: {
    cursor: "pointer"
  }
})

const BottomSectionComponent = React.memo(withStyles(bottom_section_styles)(({
  classes,
  org,
  suborg_change_available,
  onClick,
  drawer_open,
  orgs_state: {
    selected_org,
    selected_property
  }
}) => {

//  const [pressed, set_pressed] = React.useState(false);
  const ref = React.createRef();

  function handle_click(e) {
      //set_pressed(!pressed);
      onClick(ref.current);
  }

  return (
        <div
          className = {classes.root + (suborg_change_available ? ' ' + classes.pointer : '')}
          onClick = {suborg_change_available ? handle_click : null}
        >
          <Divider />
          <ListItem classes = {{ root: classes.list_item}}>
            <ListItemIcon className = {classes.zero_margin_right}>
              <Icon type = "icon-apartment" />
            </ListItemIcon>
            <ListItemText
                primary = {selected_org && selected_org.name}
                secondary = {(selected_property && selected_property.name)}
                classes = {{
                  primary: classes.overflow,
                //  secondary: classes.secondary
                }}
            />
            {
              Boolean(suborg_change_available)
              ? (
                <div ref = {ref}>
                  <ListItemIcon className = {classes.zero_margin_right + ' ' + classes.twenty_min_width}>
                    <Icon type = "icon-triangle-up" size = "xs" className = {drawer_open ? classes.rotate_icon : classes.default_icon}/>
                  </ListItemIcon>
                </div>
              ): null
            }
         </ListItem>
        </div>
      )
}));


BottomSectionComponent.propTypes = {
  suborg_change_available: PropTypes.bool,
}


const styles = theme => ({
  paper: {
    width:'100%',
    display:'inline-block',
    flex: 1,
    overflow:'hidden',
    height:'100%',
    maxHeight:'100vh',
    maxWidth:'100vw',
  },
  paper_big_screens: {
    height:400,
    maxWidth:'600px',
  }
});

const BottomSection = ({classes,onClick, ...props}) => {

  const [anchorEl, setAnchor] = React.useState(null);

  const handleArrowRef = el => setAnchor(el);

  function handleClose() {
    setAnchor(null)
    props.onClose();
  }

  function close_bottom_section() {
    setAnchor(null)
  }
  const matches = useMediaQuery('(min-width:768px)');
  const paper_class = classes.paper + (matches ? ' ' + classes.paper_big_screens : '')

  return (
    <>
      <BottomSectionComponent onClick = {handleArrowRef} drawer_open = {Boolean(anchorEl)} {...props} />
      <Popover
        open = { Boolean(anchorEl) }
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        marginThreshold = {matches ? 16 : 0}
        anchorEl={ anchorEl }
        onClose={ handleClose }
        PaperProps = {{
          style: {
            background:"transparent",
            border:'none',
            boxShadow: "none",

          }
        }}
        classes = {{ paper: paper_class }}
      >
      <Changer {...props} close_bottom_section = {close_bottom_section}/>
    </Popover>
    </>
  )
}
//        marginThreshold = {8}

export default React.memo(withStyles(styles)(BottomSection));
